import { ReactNode, useState } from "react";
import { Container, Box, IconButton } from "@mui/material";
import Sidebar from "./SideBar";
import Topbar from "./TopBar";
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import { SIDEBAR_WIDTH } from "../constants";
import "./Layout.scss";

function MainContainer({
  children,
  hideHeader = false,
}: {
  children: ReactNode;
  hideHeader?: boolean;
}) {

  const [mobileOpen, setMobileOpen] = useState(false);
  const handleSidebarToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const [isActiveAction, setIsActiveAction] = useState(false);
  const handleClickAction = () => {
    setIsActiveAction(!isActiveAction);
  };

  return (
    <Box sx={{ display: "flex" }} className={`panel_layout ${isActiveAction ? 'panel_sidebar_closed' : ''}`}>
      <Topbar handleSidebarToggle={handleSidebarToggle} />
      <Sidebar
        mobileOpen={mobileOpen}
        handleSidebarToggle={handleSidebarToggle}
      />
      <IconButton
        className={`panel_action ${isActiveAction ? 'active' : ''}`}
        onClick={handleClickAction}
      >
        <KeyboardArrowLeftIcon />
      </IconButton>
      <Box
        className="dashboard_main mn-lyout"
        component="main"
        sx={{
          marginLeft: "auto",
          width: { lg: `calc(100% - ${SIDEBAR_WIDTH}px)` },
        }}
      >
        <Container className="sub-layout" sx={{ paddingTop: 13 }}>
          {children}
        </Container>
      </Box>
    </Box>
  );
}
export default MainContainer;
